import { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { ServiceLogo } from "@/components/ui/iconsvg";

export function SidebarShell({ children }: { children: ReactNode }) {
  return (
    <nav className="shrink-0 w-[240px] h-full bg-gradient-to-b from-maincolor to-subcolor py-4">
      <div className="flex justify-center px-4 mb-6">
        <Link to="/competitions">
          <ServiceLogo width={160} className="brightness-0 invert" />
        </Link>
      </div>
      <ul className="flex flex-col w-full">
        {children}
      </ul>
    </nav>
  );
}
